const SE = require('./locales/se')
const NO = require('./locales/no')
const FI = require('./locales/fi')

// ? ******************************************************************************************
// ? ******************************************************************************************

module.exports = {
  CALCULATOR: {
    SE,
    NO,
    FI
  }
}
